$(document).on('ready', function () {
    $.fn.cardWithPopup = function () {
        var $self = $(this);
        var $element = $self.find('.js-card-with-popup');
        var $buttonFixed = $('.js-fixed-button');
        var widthWindow = parseInt($('.js-fc-body').css('width'));
        var $newsBlock = $('.js-news');
        var tabletWidthConstant = 768;
        var opacityClass = 'opacity';
        var openClass = 'open';
        var covertClass = 'covert';


        var init = function () {
            if (widthWindow < tabletWidthConstant) {
                collapsable();
            }

            $element.each(function (index) {
                $(this).on('click', function () {
                    toggleClass(index);
                });
            });
            clickOnDocument();
        };

        var toggleClass = function (index) {
            var $item = $element.eq(index);
            var positionElement = findPosition($item).top;
            if ($item.hasClass(openClass)) {
                if (widthWindow > tabletWidthConstant) {
                    $newsBlock.removeClass(opacityClass);
                }
                removeClass();
                return;
            }
            removeClass();
            addClass();
            $buttonFixed.removeClass('active');
            var $popup = $item.find('.js-card-with-popup-popup');
            $popup.css('top', positionElement);
            $item.addClass(openClass);
            $item.removeClass(covertClass);
            if (widthWindow > tabletWidthConstant) {
                $newsBlock.addClass(opacityClass);
            }
        };

        var removeClass = function () {
            $element.each(function () {
                $(this).removeClass(openClass);
                $(this).removeClass(covertClass);
            });
        };

        var addClass = function () {
            $element.each(function () {
                $(this).addClass(covertClass);
            });
        };

        var findPosition = function (element) {
            return element.position();
        };

        var collapsable = function () {
            $element.each(function () {
                var $popup = $(this).find('.js-card-with-popup-popup');
                $popup.css('position', 'static')
            });
        };


        var clickOnDocument = function () {
            $(document).on('click', function (event) {
                if (event.target.closest('.js-card-with-popup')) {
                    return;
                }
                removeClass();
                $newsBlock.removeClass(opacityClass);
            });
        };

        init();
    };

    $('.js-card-with-popup-wrapper').each(function () {
        $(this).data('cardWithPopup', $(this).cardWithPopup());
    });

});
